import styled from 'styled-components'

// Import themes modules
import { px2Rem, boxTruncate } from '../../themes/Mixins'
import COLORS from '../../themes/Colors'
import TYPOGRAPHY from '../../themes/Typography'

// Import common component
import Title from './Title'
import Description from './Description'
import { Box } from './Box'

export const GameDescription = Description.extend`
  ${props => boxTruncate(
    props.width || '100%',
    props.height || `${px2Rem(55)}`,
    props.lineHeight || 1.29,
    props.overflow || 'hidden',
    props.padding || `${px2Rem(2.4)} 0`
  )}
`

export const Wrapper = Box.extend`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${ px2Rem(10)} ${ px2Rem(15)};
  background-image: linear-gradient(to bottom, ${COLORS.blackTransparent}, ${COLORS.black});

  ${GameDescription} {
    color: ${COLORS.white};
    font-family: ${TYPOGRAPHY.TYPE.base};
    height: auto;
    margin: 0;
  }

  @media (min-width: 768px) {
    position: initial;
    padding: 0;
    background-image: none;
    left: auto;
    bottom: auto;
    width: auto;

    ${GameDescription} {
      font-family: ${TYPOGRAPHY.TYPE.light};
      color: ${COLORS.brown};
      margin-bottom: ${px2Rem(23)};
    }
  }
`

export const LearnMore = styled.p`
  font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.xxTiny};
  font-family: ${props => props.fontFamily || TYPOGRAPHY.TYPE.bold};
  color: ${props => props.color || COLORS.red};
  display: none;

  @media(min-width: 768px) {
    display: block;
  }
`

export const Character = styled.span`
  font-size: ${props => props.fontSize || TYPOGRAPHY.SIZE.tiny};
  margin-left: ${px2Rem(10)};
`

export const Content = styled.div`
  justify-content: space-between;
  align-items: flex-start;
  display: flex;

  ${Title} {
    color: ${COLORS.white};
    font-size: ${px2Rem(16)};
    padding-right: ${px2Rem(5)};
  }

  ${Description} {
    color: ${COLORS.white};
    margin: 0;
    font-size: ${px2Rem(14)};
  }

  @media (max-width: 375px) {
    ${Title} {
      padding-right: 0;
    }
    
    ${Description} {
      text-align: right;
    }
  }

  @media (min-width: 768px) {
    display: block;

    ${Title} {
      color: ${COLORS.brown};
      font-size: ${px2Rem(18)};
    }

    ${Description} {
      color: ${COLORS.descriptionGame};
      margin-bottom: ${px2Rem(23)};
      margin-top: ${px2Rem(13)};
      text-align: left;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/common/GameDetailResponsive.js